<template>
  <div id="app" v-if="isShow">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<style lang="less">
  *{
    padding: 0;
    margin: 0;
  }
  
</style>
<script>
import {
  getEventOrgStatus
} from "@/api/api";
  export default {
    data() {
      return {
        isShow:true
      };
  },
    mounted(){
      console.log(this.$router)
      this.ongetEventOrgStatus()
    },
    methods:{
    async ongetEventOrgStatus(){
      let { code , data } = await getEventOrgStatus({
        event_id:this.$route.query.event_id
      })
      if (code == 1) {
        if (data == 0) {
          this.isShow = false
          this.$message.error({ type: 'warning', message: '当前组织已被删除，请联系系统管理员' });
        }
      }
    },
  }
  }
</script>
